{
  "manage": {
    "title": "Gérer les formulaires"
  },
  "forms": {
    "confirmation": {
      "thank_you": "Merci",
      "default_message": "Merci d'avoir soumis le formulaire. Vos informations ont été reçues avec succès.",
      "redirect_message": "Vous êtes redirigé vers",
      "nexl_branding": "Ce formulaire a été créé avec Nexl. Explorez",
      "learn_more": "pour en savoir plus"
    },
    "waitlist": {
      "settings": {
        "description": "Ajustez les paramètres de votre liste d'attente, y compris les conditions et l'URL de redirection",
        "enable_label": "Activer la liste d'attente",
        "redirect_url_label": "URL de redirection",
        "redirect_url_placeholder": "Collez l'URL ici"
      },
      "condition": {
        "label": "Condition",
        "add_button": "Ajouter une condition",
        "modal_title": "Condition",
        "modal_caption": "Effectuer l'action uniquement lorsque cette condition est remplie.",
        "rollup_field_label": "Champ de cumul",
        "select_field": "Sélectionner un champ",
        "no_rollup_field_option": "Aucun cumul n'est lié à cette liste",
        "operation_label": "Opération",
        "value_label": "Valeur",
        "operation_value_label_greater_than_or_equal_to": "est supérieur ou égal à",
        "operation_value_label_is": "est",
        "rollup_field_tooltip": "Le champ de cumul est requis pour utiliser la fonctionnalité de liste d'attente. Vous pouvez en créer un via le menu d'actions du Workspace."
      },
      "validation": {
        "redirect_url_invalid": "Veuillez saisir une URL valide",
        "redirect_url_required": "L'URL de redirection est requise",
        "field_required": "Veuillez sélectionner un champ",
        "value_number_required": "Veuillez saisir un nombre",
        "value_integer_required": "La valeur doit être un entier",
        "value_positive_required": "La valeur doit être supérieure à 0",
        "value_required": "Veuillez saisir une valeur",
        "condition_required": "Veuillez ajouter une condition"
      }
    }
  }
}
